import $ from 'jquery'

export const Header = (() => {
  'use strict'

  let body,
    header,
    menu,
    menuButton,
    subMenuParent,
    subMenuParentLink,
    subMenuItem;

  function init() {
    body = $('body')
    header = $('.header')
    menu = $('.site-header__nav .nav-items')
    menuButton = $('.mobile-menu-button')
    subMenuParent = $('.site-header .menu-item-has-children')
    subMenuItem = $('.site-header .sub-menu a')

    header.toggleClass('header--scrolled', $(window).scrollTop() > 25)

    events()
  }

  function events() {
    $(window).scroll(function () {
      header.toggleClass('header--scrolled', $(window).scrollTop() > 25)
    })

    menu.scroll(() =>
      header.toggleClass('header--menu-scrolled', menu.scrollTop() > 1)
    )

    menuButton.click(function () {
      if (menu.hasClass('open')) {
        body.removeClass('mobile-menu-open')
        menu.removeClass('open')
        menuButton.removeClass('open').attr('aria-expanded', 'false')
      } else {
        body.addClass('mobile-menu-open')
        menu.addClass('open')
        menuButton.addClass('open').attr('aria-expanded', 'true')
      }
    });

    subMenuParent.click(function (event) {
      if (innerWidth < 768) {
        event.preventDefault()
        const parent = $(this),
          link = parent.find('a')
        link.addClass('sub-menu--open')
        parent.find('.sub-menu').slideDown(200)

        parent.off('click')
        parent.click(() => (location.href = link.attr('href')))
      }
    });
  }

  return { init }
})()
